const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Crusades extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Crusades,
            "The strongest civilization scores 4 culture. The weakest civilzation loses 4 culture.",
            {}
        )
    }
}

module.exports = Crusades;